import * as yup from 'yup'

const required = 'This field is required'

const testSSN = (val: string) => {
  if (val === undefined) {
    return true
  }
  return val.length === 0 || val.trim().length === 9
}

export const validationSchema = yup.object().shape({
  action: yup
    .string()
    .test({
      name: 'upgradable',
      test: (val: string, context: any) =>
        !(val === 'upgrade_add_spouse' && context.parent.creditReportIsJoint),
      message: 'Cant upgrade when the applicant already have a joint credit report',
      exclusive: true,
    })
    .required(),
  single_or_joint: yup
    .string()
    .required(required)
    .when('action', {
      is: 'unmerge',
      then: (schema) => schema.oneOf(['single'], "Can't Unmerge a single report"),
    })
    .when('action', {
      is: 'upgrade_add_spouse',
      then: (schema) => schema.oneOf(['joint'], "Can't Upgrade a joint report"),
    }),
  file_number: yup.string().when('action', {
    is: (action: string) =>
      action === 'retrieve_existing' || action === 'unmerge' || action === 'upgrade_add_spouse',
    then: (schema) => schema.required(required),
    otherwise: (schema) => schema.optional(),
  }),
  mailing_address: yup.object().shape({
    street: yup.string().required(required),
    unit_number: yup.string().nullable(),
    city: yup.string().required(required),
    state: yup
      .string()
      .required(required)
      .test('max_length', '2 character valid state abbreviation required.', (val) => {
        if (val === undefined) {
          return true
        }
        return val.length === 0 || val.length < 5
      }),
    zip_code: yup.string().required(required),
  }),
  selectedApplicant: yup
    .string()
    .nullable()
    .when(['action', 'applicants', 'single_or_joint'], {
      is: (action: string, applicants: any[], single_or_joint: string) =>
        (action === 'upgrade_add_spouse' && applicants.length === 1) ||
        (action === 'order_new' && single_or_joint === 'joint' && applicants.length === 1),
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.required(required),
    }),
  applicants: yup.array().of(
    yup.object().shape({
      first_name: yup.string().required(required),
      last_name: yup.string().required(required),
      social_security_number: yup
        .string()
        .required(required)
        .test('min_length', 'Enter a correct value', testSSN),
    })
  ),
  newApplicant: yup.object().when(['action', 'applicants', 'single_or_joint'], {
    is: (action: string, applicants: any[], single_or_joint: string) =>
      (action === 'upgrade_add_spouse' && applicants.length === 1) ||
      (action === 'order_new' && single_or_joint === 'joint' && applicants.length === 1),
    otherwise: (schema) =>
      schema.shape({
        first_name: yup.string(),
        last_name: yup.string(),
        social_security_number: yup.string(),
      }),
    then: (schema) =>
      schema.shape({
        first_name: yup.string().required(required),
        last_name: yup.string().required(required),
        social_security_number: yup
          .string()
          .required(required)
          .test('min_length', 'Enter a correct value', testSSN),
      }),
  }),
})
